module.exports = "<!DOCTYPE HTML PUBLIC \"-//IETF//DTD HTML 2.0//EN\">\r\n<html><head>\r\n<title>404 Not Found</title>\r\n</head><body>\r\n<h1>Not Found</h1>\r\n<p>The requested URL /demos/aug-2016/13-08-2016/smart_bazaar/web/fonts/glyphicons-halflings-regular.eot was not found on this server.</p>\r\n<p>Additionally, a 404 Not Found\r\nerror was encountered while trying to use an ErrorDocument to handle the request.</p>\r\n</body></html>\r\n"


//////////////////
// WEBPACK FOOTER
// C:/Ajatus WorkSpace/Now Grocery/now-grocery/NowGroceryStoreFront/src/assets/fonts/glyphicons-halflings-regulard41d.html
// module id = ../../../../../src/assets/fonts/glyphicons-halflings-regulard41d.html
// module chunks = styles